'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _propTypes3 = require('../propTypes'),
    _themes = require('../themes'),
    _icons = require('../icons'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  div: {}
};
Styled.div.root = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxIcon__root'
})(['width:14px;height:14px;border-radius:50%;box-shadow:0 0 0 ', ' ', ';transition-property:none;transition-duration:', ';'], function (props) {
  return props.sc.focused ? '7px' : 0;
}, function (props) {
  return props.sc.highlightColor;
}, function (props) {
  return props.theme.vstui.transition.duration.shortest;
});

var CheckboxIcon = function (_React$Component) {
  function CheckboxIcon() {
    return _classCallCheck(this, CheckboxIcon), _possibleConstructorReturn(this, (CheckboxIcon.__proto__ || Object.getPrototypeOf(CheckboxIcon)).apply(this, arguments));
  }

  return _inherits(CheckboxIcon, _React$Component), _createClass(CheckboxIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          focused = _props.focused,
          invalid = _props.invalid,
          secondary = _props.secondary,
          themeProp = _props.theme,
          theme = (0, _componentTheme2.default)(themeProp),
          variant = secondary ? 'secondary' : 'primary',
          iconColor = void 0,
          highlightColor = void 0;
      return checked ? disabled ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedDisabled'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedDisabled'],
        color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedDisabled']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedDisabled']) : invalid && focused ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedInvalidFocus'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedInvalidFocus'],
        color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedInvalidFocus']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedInvalidFocus']) : invalid ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedInvalid'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedInvalid'],
        color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedInvalid']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedInvalid']) : focused ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedFocus'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedFocus'],
        color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedFocus']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedFocus']) : (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checked'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checked'],
        color3: theme.vstui['CheckboxIcon_color_' + variant + '_checked']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checked']) : disabled ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_disabled'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_disabled'],
        color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_disabled']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_disabled']) : invalid && focused ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_invalidFocus'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'],
        color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_invalidFocus']) : invalid ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_invalid'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'],
        color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_invalid']) : focused ? (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_focus'],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_focus'],
        color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_focus']
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_focus']) : (iconColor = {
        color1: theme.vstui['CheckboxIcon_borderColor_' + variant],
        color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant],
        color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant]
      }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant]), _react2.default.createElement(Styled.div.root, {
        sc: {
          highlightColor: highlightColor,
          focused: focused,
          invalid: invalid
        },
        theme: theme
      }, _react2.default.createElement(_icons.CheckboxChecked, {
        color: iconColor,
        theme: theme
      }));
    }
  }]), CheckboxIcon;
}(_react2.default.Component);

CheckboxIcon.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  invalid: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  theme: _propTypes3.themeShape
}, CheckboxIcon.defaultProps = {
  theme: (0, _themes.createTheme)()
}, CheckboxIcon.displayName = 'CheckboxIcon';
var CheckboxIconWithTheme = (0, _themes.withTheme)(CheckboxIcon);
CheckboxIconWithTheme.WrappedComponent = CheckboxIcon, exports.default = CheckboxIconWithTheme;